const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:5001";

/**
 * Get SuperAdmin statistics and metrics
 * @param {string} token - Auth token
 * @returns {Promise<Object>} Statistics object with all metrics
 */
export const getStatistics = async (token) => {
  try {
    const response = await fetch(`${API_BASE}/api/superadmin/statistics`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
      cache: "no-store",
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch statistics");
    }

    return data;
  } catch (error) {
    console.error("Error fetching superadmin statistics:", error);
    throw error;
  }
};
